module.exports = __webpack_public_path__ + "static/img/img8.459fb4f.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/shop/img8.png
// module id = OhaZ
// module chunks = 0